export default __webpack_public_path__ + "static/media/bytes.0d2b1bc8.webp";